// extracted by mini-css-extract-plugin
export var content = "MegaMenuCard-module--content--c71c9";
export var link = "MegaMenuCard-module--link--67790";
export var megaMenuCard = "MegaMenuCard-module--mega-menu-card--b6293";